import { create } from 'zustand';

const loadState = () => {
  try {
    const savedState = localStorage.getItem('skyParamsV3');
    return savedState ? JSON.parse(savedState) : undefined;
  } catch (err) {
    console.error("Could not load sky state V3", err);
    return undefined;
  }
};

const initialState = {
  baseSize: 1.5,
  factor: 5.0,
  sparkleSpeed: 0.2,
  sparkleIntensity: 0.4,
  fade: true,
  density: 1,
  isNight: false, // Default to night mode
  dayTopColor: '#034d96', // Deep blue for top of sky
  dayHorizonColor: '#96c3ff', // Light blue for horizon
};

const useSkyStore = create((set) => ({
  ...(loadState() || initialState),

  setBaseSize: (val) => set({ baseSize: Math.max(0.1, parseFloat(val) || 1.0) }),
  setFactor: (val) => set({ factor: Math.max(0, parseFloat(val) || 4) }),
  setSparkleSpeed: (val) => set({ sparkleSpeed: Math.max(0, parseFloat(val) || 1) }),
  setSparkleIntensity: (val) => set({ sparkleIntensity: Math.max(0, parseFloat(val) || 0) }),
  setFade: (val) => set({ fade: Boolean(val) }),
  setDensity: (val) => set({ density: Math.max(0, Math.min(1, parseFloat(val) || 0.5)) }),
  setIsNight: (val) => set({ isNight: Boolean(val) }),
  setDayTopColor: (val) => set({ dayTopColor: val }),
  setDayHorizonColor: (val) => set({ dayHorizonColor: val }),
}));

export const saveSkyState = () => {
  try {
    const stateToSave = useSkyStore.getState();
    const paramsOnly = {
      baseSize: stateToSave.baseSize,
      factor: stateToSave.factor,
      sparkleSpeed: stateToSave.sparkleSpeed,
      sparkleIntensity: stateToSave.sparkleIntensity,
      fade: stateToSave.fade,
      density: stateToSave.density,
      isNight: stateToSave.isNight,
      dayTopColor: stateToSave.dayTopColor,
      dayHorizonColor: stateToSave.dayHorizonColor,
    };
    localStorage.setItem('skyParamsV3', JSON.stringify(paramsOnly));
    console.log("Sky V3 params saved to localStorage");
  } catch (err) {
    console.error("Could not save sky V3 state", err);
  }
};

export default useSkyStore; 